const languageTypes = {
    ANY: 'xx',
    AR: 'ar',
    CS: 'cs',
    DE: 'de',
    EN: 'en',
    ES: 'es',
    FR: 'fr',
    IT: 'it',
    JA: 'ja',
    NB: 'nb',
    NL: 'nl',
    PL: 'pl',
    PT: 'pt',
    SV: 'sv',
    ZH_CN: 'zh-cn',
    ZH_TW: 'zh-tw',
};

export default languageTypes;
